import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/client';

import { apolloClient } from "./ApolloClient";

import AppRouterWithInitialData from './components/global/AppRouter/AppRouterWithInitialData';

import 'SassStyles/index.scss';
import 'antd/dist/antd.css';


class App extends React.Component {

  render(){

    return(

      <ApolloProvider client={apolloClient}>

        <AppRouterWithInitialData />

      </ApolloProvider>

    );

  }

}

ReactDOM.render(<App />, document.getElementById('root'));